"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const SnackbarErrorWithTitle_1 = tslib_1.__importDefault(require("./SnackbarErrorWithTitle"));
const SnackbarErrorWithoutTitle_1 = tslib_1.__importDefault(require("./SnackbarErrorWithoutTitle"));
/**
 *
 * @category component
 */
const SnackbarError = react_1.default.forwardRef(({ title, ...rest }, ref) => title ? (react_1.default.createElement(SnackbarErrorWithTitle_1.default, { ref: ref, title: title, ...rest })) : (react_1.default.createElement(SnackbarErrorWithoutTitle_1.default, { ref: ref, ...rest })));
exports.default = SnackbarError;
